export default __webpack_public_path__ + "static/media/eyLogo.ce642c17.jpg";